function formatJson(value: unknown): string | null {
  if (value === null || value === undefined) return null;
  // Never truncated: the admin must see exactly what they approve (the block scrolls).
  return JSON.stringify(value, null, 2);
}

export function ActionJsonBlock({ label, value }: { label: string; value: unknown }) {
  const text = formatJson(value);
  if (!text) return null;
  return (
    <div>
      <div className="mb-0.5 text-[11px] font-medium uppercase text-slate-500 dark:text-slate-400">
        {label}
      </div>
      <pre className="max-h-40 overflow-auto rounded-md bg-slate-100 p-2 text-xs text-slate-800 dark:bg-slate-900 dark:text-slate-200">
        {text}
      </pre>
    </div>
  );
}
